import { createContext, useContext, useState } from "react";

const OnboardingContext = createContext({ tourRunning: false, setTourRunning: () => {} });

export function OnboardingProvider({ children }) {
  const [tourRunning, setTourRunning] = useState(false);
  return (
    <OnboardingContext.Provider value={{ tourRunning, setTourRunning }}>
      {children}
    </OnboardingContext.Provider>
  );
}

export const useOnboarding = () => useContext(OnboardingContext);
